export enum LOGON_METHOD {
  NOT_LOGGED_IN = "not_logged_in",
  NATIVE = "native",
  FACEBOOK = "facebook",
  GOOGLE = "google",
  APPLE = "apple",
  GUEST = "guest",
  PENDING = "pending",
}

export enum Status {
  FAILED,
  SUCCESS,
}
